<h2>Filtrar Lactaciones</h2>
<div class="redil-info">
	<div class="body">
		<section>
			<div class="info">
				<div class="info-row">
					<label for="input-id">Animal</label>
					<input
						id="input-id"
						class="ui-inputtext"
						type="text"
						[(ngModel)]="filters.officialId"
						placeholder="Id oficial"
						pInputText
					/>
				</div>
				<div class="info-row">
					<label for="input-control">Ganadería</label>
					<p-multiSelect
						defaultLabel="Ganadería"
						maxSelectedLabels="2"
						selectedItemsLabel="{0} Seleccionados"
						[options]="farms"
						[(ngModel)]="filters.farm"
						optionLabel="name"
					>
					</p-multiSelect>
				</div>

				<div class="info-row">
					<label for="input-control">Método de ordeño</label>
					<p-multiSelect
						defaultLabel="Método de ordeño"
						maxSelectedLabels="4"
						selectedItemsLabel="{0} Seleccionados"
						[options]="methods"
						[(ngModel)]="filters.milkingMethods"
						optionLabel="name"
					>
					</p-multiSelect>
				</div>

				<div class="info-row">
					<label for="input-certifiable">Certificable</label>
					<p-dropdown
						[options]="certifiableOptions"
						[(ngModel)]="filters.certifiable"
						placeholder="Todos"
						optionLabel="name"
						[style]="{ width: '100%' }"
					></p-dropdown>
				</div>

				<div class="info-row">
					<label for="control-date" class="date-label">Fecha de secado</label>
					<p class="date-interval">Desde:</p>
					<p-calendar
						id="control-date"
						appUseUtc
						[(ngModel)]="filters.dryDate.start"
						[locale]="es.calendar_es"
						dateFormat="dd/mm/yy"
						[showIcon]="true"
						[appendTo]="'body'"
						[placeholder]="'24/06/1998'"
					></p-calendar>
					<p class="date-interval">Hasta:</p>
					<p-calendar
						id="control-date"
						appUseUtc
						[(ngModel)]="filters.dryDate.end"
						[locale]="es.calendar_es"
						dateFormat="dd/mm/yy"
						[showIcon]="true"
						[appendTo]="'body'"
						[placeholder]="'24/06/1998'"
					>
					</p-calendar>
				</div>
			</div>
		</section>
		<div></div>
		<div class="centered">
			<button (click)="onSaveFilters()" class="app-btn orange">Guardar Filtros</button>
			<button (click)="onClearFilters()" class="app-btn primary">Borrar Filtros</button>
		</div>
	</div>
</div>
